export class Song {
    constructor() {
    }

    songId: string;
    name: string;
    artistId: string;
    artistName: string;
    albumId: string;
    albumName: string;
    albumPicture: string;
    songUrl: string;
    isPartOfPlaylist: boolean;
    playlistSongId: string;
    genreSongId: string;
    genreSongName: string;
    isPlaying: boolean;
    songPicture: string;
    duration: string;

}
